// extracted by mini-css-extract-plugin
export default {"file__text":"azB0q","file__button":"rdxkA","file__size":"yZ3g0","file--error":"mzW6I"};